import React from "react";
import { AccountSource } from "@common/types/domains/accounting/account";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const options: FilterMultiselectOption[] = [
    { value: AccountSource.KICK, label: "Kick", searchableLabel: "kick" },
    { value: AccountSource.CUSTOM, label: "Custom", searchableLabel: "custom" },
];

export const AccountSourceFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.accountSource ? [filters.accountSource] : [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const added = val.find(
                        (v) => v !== filters.accountSource,
                    ) as AccountSource | undefined;
                    onChange({
                        accountSource:
                            val.length === 0
                                ? undefined
                                : (added ?? (val[0] as AccountSource)),
                    });
                }}
                name="accountSource"
                onBlur={noop}
            />
        </div>
    );
};
